<script>
   import { dvn,lge } from './store.js';
   import { createEventDispatcher } from 'svelte';
   import { push } from 'svelte-spa-router';
    
   dvn.useLocalStorage();
   const dispatch = createEventDispatcher();
</script>

<style>
	button {
	border: none;
	border-radius: 12px;
	color: white;
	padding: 10px;
	text-align: center;
	text-decoration: none;
	display: inline-block;
	font-size: 16px;
	margin: 6px 4px;
	}
	
	.block {
    display: flex;
    flex-flow: row wrap;
    justify-content: space-around;
	}
	
	#footer {
     position: absolute;
     bottom:0;
     width:100%;
	}
	
	.bon {
      background-color : #0cd1e8;
    }

    .boff {
      background-color: #3880ff;
    }

    .flip {
	  background-color:	#7044ff;
	}
</style>

<div id="footer">  
<div class="block">
    <button class="button {$dvn === 0 ? 'bon' : 'boff'}" on:click={() => {$dvn=0; dispatch('LgeUpd')}}>PRM</button>
    <button class="button {$dvn === 1 ? 'bon' : 'boff'}" on:click={() => {$dvn=1; dispatch('LgeUpd')}}>1ST</button>
	<button class="button {$dvn === 2 ? 'bon' : 'boff'}" on:click={() => {$dvn=2; dispatch('LgeUpd')}}>2ND</button>
	{#if $lge < 10}
	<button class="button {$dvn === 3 ? 'bon' : 'boff'}" on:click={() => {$dvn=3; dispatch('LgeUpd')}}>3RD</button>
	{/if}
    {#if $lge < 5}
	<button class="button {$dvn === 4 ? 'bon' : 'boff'}" on:click={() => {$dvn=4; dispatch('LgeUpd')}}>4TH</button>
	{/if}
</div>
<div class="block"><button class="button flip" on:click={() => push('/cmp')}>Competitions</button></div>
</div>